module.exports = "/_next/static/pages/testing-environment/0cf3d3064cc8c48838e04ac593f148e0.png";